import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { LocalPlayerCard } from '../../../components/cards';

import { getLocalPlayers, applySearchFilters } from '../../../actions/search-actions';

const LocalPlayers = (props) => {
    // component props
    const { filterPreferences } = props;
    // redux mapping
    const { localPlayers = [], loading, auth } = props;

    useEffect(() => {
        if (!localPlayers.length && !loading) {
            props.getLocalPlayers(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filterPreferences;
        props.applySearchFilters({
            type: 'players',
            startDate: moment(new Date()),
            distance,
            location,
            lat,
            lng,
            utrMin,
            utrMax,
            gender,
        }, true);
        props.history.push('/search');
    };
    const { feedPreferences: { showTennisContent, showPickleballContent } } = auth;
    const filteredLocalPlayers = localPlayers.filter(event => (
        (!!showTennisContent && (event.source.myUtrDoublesDisplay || event.source.myUtrSinglesDisplay)) ||
        (!!showPickleballContent && (!event.source.myUtrDoublesDisplay && !event.source.myUtrSinglesDisplay))
    ));

    return (
        <div>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'Local Players'} data-testid="dashboard.local-players.section-heading" />
                        <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.local-players.view-all-btn">
                            View All
                        </div>
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {filteredLocalPlayers?.length ? (
                    filteredLocalPlayers.map((hit) => {
                        return (
                            <div
                                className={`col-12 col-md-2`}
                                key={hit.source.id}
                            >
                                <LocalPlayerCard
                                    player={hit.source}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    data-testid={`dashboard.local-players.item-${hit.source.id}`}
                                />
                            </div>
                        );
                    })
                ) : (
                    <div className="col" data-testid="dashboard.local-players.empty-message">There are no players in your area</div>
                )}
            </div>
        </div>
    );
};

function mapStateToProps({ homepage, auth }) {
    const { localPlayers = {} } = homepage;
    const { data, loading, error } = localPlayers;
    return { localPlayers: data, loading, error, auth };
}
const mapDispatchToProps = {
    getLocalPlayers,
    applySearchFilters,
};

LocalPlayers.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocalPlayers));
